<template>
  <EregForm/>
</template>

<script>
import EregForm from './components/EregForm.vue'

export default {
  name: 'App',
  components: {
    EregForm
  }
}
</script>

<style scoped>

</style>
